import { LogicTypes } from '../../../shared/DataGrid';

export const GET_SECURITY_TRIPS_REQUEST = 'GET_SECURITY_TRIPS_REQUEST' as const;
export const GET_SECURITY_TRIPS_SUCCESS = 'GET_SECURITY_TRIPS_SUCCESS' as const;
export const GET_SECURITY_TRIPS_ERROR = 'GET_SECURITY_TRIPS_ERROR' as const;
export const GET_SECURITY_UNLOADING_TRIPS_REQUEST = 'GET_SECURITY_UNLOADING_TRIPS_REQUEST' as const;

export const GetTripColumnsNames = (isLoading: boolean) => {
  const res = {
    id: 'Рейс',
    bookingDate: 'Дата бронювання',
    statusStr: 'Статус',
    arrivalDate: "В'їзд",
    vehicleLicensePlate: 'Держномер ТЗ',
    trailerLicensePlate: 'Держномер причепа',
    driver: 'Водій',
    driverPhone: 'Телефон',
    forwarder: 'Експедитор',
    forwarderPhone: 'Телефон (Експедитор)',
  };

  if (isLoading) {
    // @ts-ignore
    res.orders = 'Номер Наряда';
    // @ts-ignore
    res.factWeightGrouped = 'Фактична вага,т (ТСД)';
    // @ts-ignore
    res.factoryNumber = 'Номер Заводу';
    // @ts-ignore
    res.warehouseCode = 'Номер Складу';
  } else {
    // @ts-ignore
    res.unloadingLocation = 'Локація';
    // @ts-ignore
    res.unloadingFactory = 'Номер Заводу';
    // @ts-ignore
    res.unloadingWarehouse = 'Номер Складу';
  }
  return res;
};

export const AWAITING_DEPARTURE_STATUS_ID = 6;
export const MIN_FILTER_VALUE_LENGTH = 3;

export const defaultGridState = {
  sort: [],
  filter: {
    logic: LogicTypes.and,
    filters: [],
  },
  pagination: { skip: 0, pageSize: 15 },
};
